<template>
    <div class="">
        <b-row class="justify-content-center">
            <h5>{{ labels.title }}</h5>
        </b-row>
        <b-row class="justify-content-center">
            <b-col cols="1"></b-col>
            <b-col cols="3" class="text-left">
                <h5>{{labels.calificacion}}</h5>
            </b-col>
            <b-col cols="2" class="text-left">
                <h5>{{ calificacion }}</h5>
            </b-col>
            <b-col cols="6" class="text-left">
                <h5><label>Score</label></h5>
                <select v-model="zscore" @click="f_seleccione_variables()">
                    <option
                        v-for="(item, idx) in listTasasScore"
                        :key="idx"
                        :value="item.tipo_tasa">
                        {{item.descripcion}}
                    </option>
                </select>
            </b-col>
        </b-row>
        <div v-if="zscore != ''" >
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.tasaUsa}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="number" v-model="TasasByVigencia.tasa_usa" class="form-control">
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.tasaLibreRiesgo}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="number" v-model="TasasByVigencia.tasa_libre_riesgo" class="form-control">
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.inflacionUsa}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="number" v-model="TasasByVigencia.inflacion_usa" class="form-control">
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.inflacionCol}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="number" v-model="TasasByVigencia.inflacion_col" class="form-control">
                </b-col>
            </b-row>
            <b-row>
                <b-col cols="1"></b-col>
                <b-col cols="5" class="text-left">
                    <h5>{{labels.embi}}</h5>
                </b-col>
                <b-col cols="6" class="text-left">
                    <input type="number" v-model="TasasByVigencia.embi" class="form-control">
                </b-col>
            </b-row>
            <md-dialog-actions class="" >
                <md-button class="md-primary" @click="guardarClasificacion">{{ labels.save }}</md-button>
            </md-dialog-actions>
        </div>
    </div>
</template>

<script>
import ClasificacionTasas from '../../../services/ClasificacionTasas';
import Score from '../../../services/Score';
import TipoTasa from "../../../services/TipoTasas"

export default {
    name : 'clasificacion',
    props : ['infoVigencia'],
    data : () => ({
        tasaUsa : '',
        tasaLibreRiesgo : '',
        inflacionUsa : '',
        inflacionCol : '',
        embi : '',
        listTasas : [],
        listTasasScore : [],
        TasasByVigencia : {},
        calificacion : '',
    zscore : '',
    fgl_grabar: false,
    fgl_existe: false,

    }),
    computed:{
        labels(){
            if(this.$store.state._language == "es-ES"){
                return {
                    title : 'Variables de Calificación',
                    calificacion : 'Calificación',
                    tasaUsa : 'Tasa USA',
                    tasaLibreRiesgo : 'Tasa libre de riesgo',
                    inflacionUsa : 'Inflación USA',
                    inflacionCol : 'Inflación COL',
                    embi : 'EMBI',
                    save : 'Guardar',
                    edit : 'Editar'
                }
            }else{
                return {
                    title : 'Classification variables',
                    calificacion : 'Qualification',
                    tasaUsa : 'US Rate',
                    tasaLibreRiesgo : 'Risk free rate',
                    inflacionUsa : 'Inflation USA',
                    inflacionCol : 'Inflation COL',
                    embi : 'EMBI',
                    save : 'Save',
                    edit : 'Edit'
                }
            }
        }
    },
methods : {
    guardarClasificacion(){
        this.f_grabe_informacion()
        if	(this.fgl_grabar == false) {
            this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            return
        }

        const datos = [
            this.TasasByVigencia.tasa_usa,
            this.TasasByVigencia.tasa_libre_riesgo,
            this.TasasByVigencia.inflacion_usa,
            this.TasasByVigencia.inflacion_col,
            this.TasasByVigencia.embi,
        ]

        if	(datos.includes('')){
            this.$toast.error('Campo(s) pendiente(s) por diligenciar')
            return
        }


        let info = {
            'vigencia' : this.infoVigencia,
            'calificacion' : this.calificacion,
            'tipo_tasa' : this.zscore,
            'tasaUsa' : this.TasasByVigencia.tasa_usa,
            'tasaLibreRiesgo' : this.TasasByVigencia.tasa_libre_riesgo,
            'inflacionUsa' : this.TasasByVigencia.inflacion_usa,
            'inflacionCol' : this.TasasByVigencia.inflacion_col,
            'embi' : this.TasasByVigencia.embi,
            'idUser' : this.$store.state.userId
        }

        ClasificacionTasas.createClasificacionTasas(info)
        .then((res) => {
            if	(res.status == 201){
                this.$toast.success(res.data.message)
            }
        })
        .catch((err) =>  {
            this.$toast.error("Problema al grabar Informacion")
            console.log(err)
        })
        },
    f_seleccione_variables() {
        ClasificacionTasas.getAllClasificacionTasas(
            this.infoVigencia,
            this.calificacion,
            this.zscore)
        .then((res) => {
            this.listTasas = res.data.clasificacionTasa
            this.TasasByVigencia = {}
            if	(this.listTasas.length>0) {
                this.TasasByVigencia = this.listTasas.find((zscore) => zscore.tipo_tasa == this.zscore)
                if	(this.TasasByVigencia == undefined) {
                    this.TasasByVigencia=this.listTasas[0]
                    this.TasasByVigencia.tipo_tasa=this.zscore
                }
            }
            this.f_grabe_informacion()
        })
        .catch((error) => console.log(error))
    },
    f_grabe_informacion() {
        if	(this.TasasByVigencia == undefined) {
            this.TasasByVigencia.calificacion = this.calificacion
            this.TasasByVigencia.vigencia = this.infoVigencia
            this.TasasByVigencia.tipo_tasa = this.zscore
        }
        this.fgl_grabar=true
        if	(this.TasasByVigencia.calificacion == undefined) {
            this.TasasByVigencia.calificacion = this.calificacion
            this.TasasByVigencia.vigencia = this.infoVigencia
            this.TasasByVigencia.tipo_tasa = this.zscore
        }
        if	(this.TasasByVigencia.inflacion_col == undefined ||
            this.TasasByVigencia.inflacion_col == null ||
            this.TasasByVigencia.inflacion_col.length == 0) {
            this.fgl_grabar=false
        }
        if	(this.TasasByVigencia.inflacion_usa == undefined ||
            this.TasasByVigencia.inflacion_usa == null ||
            this.TasasByVigencia.inflacion_usa.length == 0) {
            this.fgl_grabar=false
        }
        if	(this.TasasByVigencia.tasa_libre_riesgo == undefined ||
            this.TasasByVigencia.tasa_libre_riesgo == null ||
            this.TasasByVigencia.tasa_libre_riesgo.length == 0) {
            this.fgl_grabar=false
        }
        if	(this.TasasByVigencia.tasa_usa == undefined ||
            this.TasasByVigencia.tasa_usa == null ||
            this.TasasByVigencia.tasa_usa.length == 0) {
            this.fgl_grabar=false
        }
        if	(this.TasasByVigencia.embi == undefined ||
            this.TasasByVigencia.embi == null ||
            this.TasasByVigencia.embi.length == 0) {
            this.fgl_grabar=false
        }
    },

    },
    mounted(){
        Score.getAllScorexByVigencia(this.infoVigencia)
        .then((res) => {
            this.calificacion = res.data.qryScoreX[0].calificacion
        })
        .catch((error) => console.log(error))

        TipoTasa.leaTasasZScore()
        .then((res) => {
            this.listTasasScore = res.data.listTipoTasas
        })
        .catch((error) => console.log(error))
    this.zscore = ''


    }
}
</script>

<style>

</style>
